import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../core/state/app.reducer';
import { QS } from '../../core/utils/quicksort';
import { Store } from '@ngrx/store';

import { LinesCase } from '../../core/models/linescases.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BusLine } from '../../core/models/busline.model';

import * as fromComplaintsSelector from '../../pages/home/state/complaints.selectors';
import { BusLinesComplaintsComponent } from '../modals/bus-lines-complaints/bus-lines-complaints.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { List } from 'cypress/types/lodash';
import { Denounce } from '../../core/models/denounce.model';
import { ComplaintsService } from '../../core/services/complaints.service';

@Component({
	selector: 'app-bus-lines',
	templateUrl: './bus-lines.component.html',
	styleUrls: ['./bus-lines.component.scss'],
})
export class BusLinesComponent implements OnInit {
	// Lists
	ELEMENT_DATA: LinesCase[] = [];
	busLines = [];
	complaintsByBusLines: List<Denounce> = [];
	// Flags
	loading = true;

	@ViewChild(MatPaginator, { static: false })
	set paginator(value: MatPaginator) {
		if (this.dataSource) {
			this.dataSource.paginator = value;
		}
	}

	dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

	displayedColumns: string[] = ['line', 'case'];
	displayedColumnsDenounces: string[] = [
		'id',
		'denouncer',
		'date',
		'status',
		'action',
	];

	constructor(
		private store: Store<AppState>,
		public dialog: MatDialog,
		private complaintsService: ComplaintsService,
	) { }

	ngOnInit(): void {
		this.store
			.select(fromComplaintsSelector.selectBusLines)
			.subscribe((busLines) => {
				this.busLines = busLines;
				this.sortLines();
			});

	}

	sortLines(): void {
		const busL = [...this.busLines];

		const modifiedBusL = busL.map((c) =>
			c.line === '' ? { cases: c.cases, line: 'Não identificado' } : c
		);

		QS(modifiedBusL);

		this.dataSource.data = modifiedBusL;
		this.loading = false;
	}

	openComplaintByBusLines(bus_name): void {
		this.dialog.closeAll()
		this.dialog.open(BusLinesComplaintsComponent, {
			panelClass: 'read-modal',
			height: 'auto',
			width: '600px',
			data: {
				line_name: bus_name,
			},
		});
	}
}
